import React from 'react';

const CeBrownIcon = (props: any) => {
  const { ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      {...rest}
    >
      <rect width="20" height="20" y="0.5" fill="#9F7058" rx="4"></rect>
      <path
        fill="#fff"
        d="M3.333 10.51c0 2.084 1.796 3.74 4.027 3.74.993 0 1.952-.323 2.71-1.01.079-.073.101-.209.012-.282l-.513-.468c-.067-.053-.167-.063-.268.01-.535.385-1.104.688-1.918.688-1.596 0-2.811-1.24-2.811-2.698 0-1.459 1.204-2.709 2.8-2.709.691 0 1.405.271 1.93.698.1.094.2.094.278 0l.49-.469c.09-.083.09-.208-.01-.291-.759-.615-1.573-.969-2.7-.969-2.23 0-4.027 1.677-4.027 3.76zM11.78 13.948c0 .104.09.198.213.198h4.462a.205.205 0 00.212-.198v-.573a.205.205 0 00-.212-.198H12.93v-2.24h2.978c.112 0 .212-.083.212-.197v-.584c0-.104-.1-.198-.212-.198H12.93V7.833h3.525a.205.205 0 00.212-.198v-.583a.205.205 0 00-.212-.198h-4.462a.205.205 0 00-.212.198v6.896z"
      ></path>
    </svg>
  );
};

export default CeBrownIcon;
